export const rawPairs = [
  ["rub_card_number", "RUB Card"],
  ["rub_fps", "RUB FPS"],
  ["rub_transgran_phone", "TS Phone"],
  ["rub_transgran_card", "TS Card"],
  ["bol_bank_transfer", "BOL Bank Transfer"],
  ["bol_qr_code", "BOL QR Code"],
  ["ven_pago_movil", "VEN Pago Movil"],
  ["ven_qr_code", "VEN QR Code"],
  ["ven_account_number", "VEN Account Number"],
  ["ecu_account_number", "ECU Account Number"],
  ["ecu_phone_number", "ECU Phone Number"],
  ["krw_bank_transfer", "KRW Bank Transfer"],
  ["krw_kakao_pay", "KRW Kakao Pay"],
  ["ars_mercado_pago", "ARS Mercado Pago"],
  ["ars_lemon_cash", "ARS Lemon Cash"],
  ["inr_upi_intent", "INR UPI Intent"],
  ["bdt_bkash", "BDT bKash"],
  ["bdt_nagad", "BDT Nagad"],
  ["rub_mob_com", "RUB Mobile"],
  ["RUB", "Рубли"],
  ["KRW", "Воны"],
  ["SM", "Сомони"],
  ["INR", "Рупии"],
  ["ARS", "Песо"],
  ["KZT", "Тенге"],
  ["BOL", "Боливиано"],
  ["VES", "Боливар"],
  ["PEN", "Соль"],
  ["BDT", "Така"],
  ["UZS", "Сум"],
  ["AZN", "Манат"],
  ["KGS", "Сом"],
  ["IDR", "Рупия"],
  ["PKR", "Рупи"],
  ["TRY", "Лира"],
  ["VND", "Донг"],
  ["PHP", "Песо"],
  ["THB", "Тайский бат"],
  ["CAD", "Канадский доллар"],
];
export const symbols: Record<string, string> = {
  RUB: "₽",
  KRW: "₩",
  SM: "ЅМ",
  INR: "₹",
  ARS: "$",
  KZT: "₸",
  BOL: "b$",
  VES: "Bs",
  PEN: "S",
  BDT: "৳",
  UZS: "soʻm",
  USDT: "USDT",
  AZN: "₼",
  KGS: "⃀",
  PHP: "₱",
  VND: "₫",
  TRY: "₺",
  PKR: "Rs",
  IDR: "Rp",
  THB: "฿",
  CAD: "C$",
};
export const dictionary = Object.fromEntries(rawPairs);
export const reverseDictionary = Object.fromEntries(
  rawPairs.map(([k, v]) => [v, k]),
);
export const translate = (val: any) => dictionary[val] || val;
export const reverseTranslate = (val: any) => reverseDictionary[val] || val;
export const currencyMeta: Record<
  string,
  {
    label: string;
    img: string;
  }
> = {
  INR: { label: "Рупии", img: "/images/india.png" },
  KRW: { label: "Воны", img: "/images/sk.png" },
  SM: { label: "Сомони", img: "/images/tj.png" },
  RUB: { label: "Рубли", img: "/images/rus.png" },
  ARS: { label: "Песо", img: "/images/arg.png" },
  KZT: { label: "Тенге", img: "/images/kz.png" },
  UZS: { label: "Сум", img: "/images/uzs.png" },
  BDT: { label: "Така", img: "/images/BDT.png" },
  PEN: { label: "Соль", img: "/images/PEN.png" },
  VES: { label: "Боливар", img: "/images/VES.png" },
  BOL: { label: "Боливиано", img: "/images/BOB.png" },
  USDT: { label: "USDT", img: "/images/USDT.png" },
  AZN: { label: "Манат", img: "/images/AZN.png" },
  KGS: { label: "Сом", img: "/images/KGS.png" },
  PHP: { label: "Песо", img: "/images/PHP.png" },
  VND: { label: "Донг", img: "/images/VND.png" },
  TRY: { label: "Лира", img: "/images/TRY.png" },
  PKR: { label: "Рупи", img: "/images/PKR.png" },
  IDR: { label: "Рупия", img: "/images/IDR.png" },
  THB: { label: "Тайский бат", img: "/images/THB.png" },
  CAD: { label: "Канадский доллар", img: "/images/CAD.png" },
};

export const checkButton = (array: any, form: any) => {
  return array?.some(
    (item: any) =>
      item.operation_type === form.operation_type &&
      item.currency === reverseTranslate(form.currency) &&
      item.payment_method === form.payment_method,
  );
};
